import { ReactNode } from 'react';

import { ModalFrameSize } from 'components/ui/modal-frame';
import { NoticeModal } from 'components/ui/notice-modal';
import { useModal } from 'context/ModalContext';

interface HelpModalProps {
  /** Identificador com que a tela abre a ajuda: `showModal(modalId)`. */
  modalId: string;
  title: string;
  size?: ModalFrameSize;
  children: ReactNode;
}

/** Ajuda aberta pelo `ModalContext`: o texto e um "Entendi", na moldura dos modais da nova identidade. */
export function HelpModal({ modalId, title, size = 'sm', children }: HelpModalProps) {
  const { openModal, closeModal } = useModal();

  return (
    <NoticeModal
      isOpen={openModal === modalId}
      size={size}
      title={title}
      actionLabel="Entendi"
      onAction={closeModal}
      onClose={closeModal}
    >
      {children}
    </NoticeModal>
  );
}
